import { ArrowDown, ArrowUp } from '@phosphor-icons/react';
import { cn, Stack } from '@reelplicate/ui';

export type Stat = {
  label: string;
  value: string;
  /** "+31%", "−2" - null when there's nothing to compare with. */
  delta: string | null;
  up: boolean;
};

/**
 * Figma "Stat Tile" (65:61): label, a Data/Stat value with a delta chip
 * (arrow + change - never colour alone), and the comparison period.
 */
export function StatTile({ stat }: { stat: Stat }) {
  const Arrow = stat.up ? ArrowUp : ArrowDown;
  return (
    <Stack gap={2} className="min-w-0 flex-1 p-5">
      <dt className="text-body-sm text-text-secondary">{stat.label}</dt>
      <Stack as="dd" gap={2}>
        <span className="flex items-baseline gap-2">
          <span className="text-data-stat text-text-primary">{stat.value}</span>
          {stat.delta && (
            <span
              className={cn(
                'text-label-sm flex items-center gap-0.5 self-center rounded-xs px-1.5 py-0.5',
                stat.up
                  ? 'bg-status-success-bg text-status-success-fg'
                  : 'bg-status-danger-bg text-status-danger-fg',
              )}
            >
              <Arrow aria-hidden className="size-3" />
              <span className="sr-only">{stat.up ? 'Up' : 'Down'} </span>
              {stat.delta}
            </span>
          )}
        </span>
        <span className="text-caption text-text-tertiary">vs last week</span>
      </Stack>
    </Stack>
  );
}
